module.exports = __webpack_public_path__ + "static/img/jjfa_03.2049291.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jjfa_03.jpg
// module id = xNm3
// module chunks = 1